import { PAGE_CACHE_HEADERS } from "@/lib/ssrCache";
import { ensureExists } from "@/lib/ensureExists";
import { createFileRoute } from "@tanstack/react-router";
import ChainsawProduct from "@/pages/ChainsawProduct";
import { redirectIfPruned } from "@/lib/prunedRedirect";

export const Route = createFileRoute("/chainsaws/$slug")({
  beforeLoad: async ({ params }) => {
    await redirectIfPruned("chainsaws", params.slug);
    await ensureExists("chainsaws", params.slug);
  },
  component: ChainsawProduct,
  headers: () => PAGE_CACHE_HEADERS,
  head: ({ params }) => {
    const canonicalUrl = "https://www.garden-review.co.uk" + `/chainsaws/${params.slug}`;
    return {
      links: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
});
